import { categoryNames } from '@/components/partials/war-room/WarRoomPostForm/WarRoomPostFormCategories/constants';
import { WAR_ROOM_POSTS_TAB } from '~/constants';

export const postTypes = Object.freeze({
  STORY: 'story',
  LINK: 'link',
  YOUTUBE: 'youtube_link',
  LINKEDIN: 'linkedin_post',
});

export const authorTypes = Object.freeze({
  PUBLIC: 'public',
  ANONYMOUS: 'anonymous',
});

export const LAST_NESTING_LEVEL = 3;

export const achievementLevels = Object.freeze({
  NO_LEVEL: 'no_level',
  GOLD: 'gold',
  SILVER: 'silver',
  BRONZE: 'bronze',
  PLATINUM: 'platinum',
});

export const achievementSizes = Object.freeze({
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
});

export const modalNames = Object.freeze({
  TOPICS_LIST: 'topics-list',
  SHARE_POST_OR_COMMENT: 'share-post-or-comment',
  VIEW_NOTE: 'view-note',
});

export const confirmNames = Object.freeze({
  DELETE_POST: 'confirm-delete-post',
  DELETE_NOTE: 'confirm-delete-note',
});

export const categoryMeta = {
  [categoryNames.QUESTION]: {
    title:
      'Ask sales related questions and get answers from fellow sales professionals within the Bravado War Room community',
    description:
      'War Room members ask questions about sales, selling, business development, lead generation, emailing, compensation, prospecting, closing, and cold calling',
  },
  [categoryNames.ADVICE]: {
    title: 'Get real advice on your career from experienced sales professionals within the Bravado War Room',
    description:
      'Bravado is a community where salespeople get advice, share their experiences, find resources, and gain useful recommendations',
  },
  [categoryNames.DISCUSSION]: {
    title: 'Start a discussion on any sales related topic with other members in the Bravado War Room community',
    description:
      'The War Room is a place for interesting discussions on sales topics like qualification calls, networking demos, career advice, and compensation plans',
  },
  [categoryNames.OFFICIAL]: {
    title: 'Best sales content, tutorial videos, contests, and official announcements posted by the Bravado War Room',
    description:
      'Weekly and monthly sales contests held by the Bravado War Room Community as well as useful sales content for any sales executive',
  },
  [categoryNames.WIN_WIRE]: {
    title: 'Sales Win Wire: the best closed-won deal stories',
    description:
      'Share with and learn from top sales professionals how to sell and close deals. Celebrate your closed-won deals with the Bravado War Room',
  },
};

export const warRoomStates = Object.freeze({
  OUTSIDER: 'outsider',
  IN_ONBOARDING: 'in_onboarding',
  MEMBER: 'member',
});

export const votableTypes = Object.freeze({
  POST: 'post',
  COMMENT: 'comment',
  DEAL: 'deal',
});

export const gqlVotableTypes = Object.freeze({
  POST: 'WarRoom::Post',
  COMMENT: 'WarRoom::Comment',
});

export const TABS_QUERY_PARAM = 'tab';

export const feedTabKeys = Object.freeze({
  MY_FEED_TAB: 'my_feed',
  HOT_TAB: 'hot',
  NEW_TAB: 'new',
});

export const feedTabNames: Record<string, string> = Object.freeze({
  my_feed: 'Feed',
  hot: 'Hot',
  new: 'New',
});

export const myFeedTab = Object.freeze({
  key: feedTabKeys.MY_FEED_TAB,
  name: 'My Feed',
  nameAnonymous: 'Feed',
});

export const hotTab = Object.freeze({
  key: feedTabKeys.HOT_TAB,
  name: 'Hot',
});

export const newTab = Object.freeze({
  key: feedTabKeys.NEW_TAB,
  name: 'New',
});

export const DEFAULT_FEED_PATH = `${WAR_ROOM_POSTS_TAB.path}/${feedTabKeys.MY_FEED_TAB}`;
export const DEFAULT_FEED_ROUTE = 'war-room-posts-tab-tab';
export const FEED_CATEGORIES_ROUTE = 'war-room-categories-categorySlug-posts';
export const FEED_TOPICS_ROUTE = 'war-room-topics-topicSlug-posts';
